import $ from 'jquery';
import '../modules/carousel';
import * as _ from 'underscore';
import { responsiveImageSizes } from './config';

export function checkCarouselFontSize() {
  $('.jumbotron .headingstyle1, .jumbotron h1').each(function () {
    var $this = $(this),
      real_width = $this.prop('scrollWidth'),
      width = $this.innerWidth(),
      font_size = parseInt($this.css("font-size"));

    if (width < real_width) {
      $this.css("font-size", font_size * (width / real_width));
    }
  });
}

export var $carousel;

export function init() {
  var complete_cycles = 0;
  $carousel = $('.heading .carousel').filter(':visible');
  if ($carousel.length) {
    checkCarouselFontSize();

    $('.jumbotron-bg').each(function () {
      var $this = $(this), data = $this.data();
      if (!data.img) {
        return;
      }

      var screenSize = $(window).width();
      var optimalSize, optimalFolder;
      _.each(responsiveImageSizes.carouselSizes, function (size, folder) {
        if (size.width >= screenSize) {
          // Will use the smallest possible resized image, that is larger than the size where the image will be used in the page (i.e. it will scale the image down, not up).
          if (optimalSize === undefined) {
            optimalSize = size.width;
            optimalFolder = folder;
          }
          else if (size.width < optimalSize) {
            optimalSize = size.width;
            optimalFolder = folder;
          }
        }
      });

      if ($(window).width() <= 425) {
        $this.css('background-image', 'none');
      } else {
        //var src = optimalFolder ? data.img.substring(0, data.img.indexOf('/cms') + 4) + '/carousel/' + optimalFolder + '/' + data.img.substring(data.img.lastIndexOf('/') + 1) : data.img;
        var src = data.img;
        $this.css('background-image', 'url(' + src + ')');
      }
    });

    setTimeout(function () {
      $carousel.carousel({ interval: false, pause: false, wrap: true });

      var interval_id = setInterval(function () {
        if ($('.carousel .item:last').hasClass('active')) {
          complete_cycles += 1;
        }

        if (complete_cycles > 0 && $('.carousel .item.active').data("stopper")) {
          clearInterval(interval_id);
        }
        else {
          $carousel.carousel('next');
          checkCarouselFontSize();
        }
      }, 5000);
    }, 1000);
  }

  // fix for all layers of carousel visible on load before styling is applied
  $('.item').attr("style", "");
}

